import React from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { UseCases } from "@planzone/core";
import { Safeguard } from "@scenes/safeguard";
import { Chatbot } from "@scenes/chatbot";
import { WorkspaceContext } from "@scenes/workspaceContext";
import { Notifications } from "@scenes/notifications";
import { AssistantShortcut } from "@scenes/assistantShortcut";
import { ProfileNavigation } from "@common/profileNavigation";
import styles from "./styles.scss";

function AssistantPage() {
  const { t } = useTranslation();

  return (
    <Safeguard useCases={[UseCases.retrieveConversations]}>
      {({ canRetrieveConversations }) =>
        canRetrieveConversations ? (
          <WorkspaceContext type="planzone">
            <div className={styles.assistantPage}>
              <div className={styles.header}>
                <h1 className={styles.title}>{t("assistantPage.title")}</h1>
                <div className={styles.profileNavigation}>
                  <AssistantShortcut />
                  <Notifications />
                  <ProfileNavigation />
                </div>
              </div>
              <div className={styles.main}>
                <Chatbot />
              </div>
            </div>
          </WorkspaceContext>
        ) : (
          <Navigate to="/" replace />
        )
      }
    </Safeguard>
  );
}

export { AssistantPage };
